import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import jwt_decode from 'jwt-decode';
import { loginSuccess, resetAuth } from 'libs/shared/data/stores/auth/auth.actions';
import { getAuthUser } from 'libs/shared/data/stores/auth/auth.selectors';
import { Observable } from 'rxjs';

import { LoginResponse } from '@offconon/core-api';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private router = inject(Router);

  private destroyRef = inject(DestroyRef);
  private store$ = inject(Store);
  currentUserSubject = this.store$.select(getAuthUser);
  currentUser: Observable<LoginResponse>;
  currentUserValue: LoginResponse | null;

  constructor() {
    this.currentUserSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((user: any) => {
      this.currentUserValue = user;
    });
  }
  login(user: LoginResponse) {
    this.store$.dispatch(loginSuccess({ loginResponse: user }));
  }
  logout() {
    this.store$.dispatch(resetAuth());
    this.router.navigate(['/login']);
  }

  isTokenExpired() {
    if (this.currentUserValue) {
      const jwtObject: any = jwt_decode(this.currentUserValue.jwt_token);
      const now = new Date();
      const exp = new Date(jwtObject.exp * 1000);
      if (exp < now) {
        return true;
      }
      return false;
    }
    return true;
  }

  handleExpiredToken() {
    if (this.isTokenExpired()) {
      this.logout();
    }
  }
}
